import React from "react";

export function CustomBadge(props: { children?: React.ReactNode }): JSX.Element {
    return <div className={"text-light bg-dark m-1"}>{props.children}</div>;
}
